<div class="component-container">
  <div class="component-header">
    <h2>Create New Shareholder Proposal Name</h2>
  </div>
  <app-company-vote-proposal-name-form
    [form]="form"
    [isEditMode]="false"
    submitButtonText="Create Shareholder Proposal Name"
    (submit)="onSubmit()"
    (cancel)="onCancel()">
  </app-company-vote-proposal-name-form>
</div>
